import { useSuspenseQuery } from "@tanstack/react-query";
import { fetchFeatures } from "../api/fetchFeatures";

export const useFeatures = (companyId: number) => {
  const { data: features } = useSuspenseQuery({
    queryKey: ["features"],
    queryFn: async () => await fetchFeatures(companyId),
    gcTime: Infinity,
    staleTime: Infinity,
  });
  return {
    hasFeature: (feature: string) => features && features.indexOf(feature) >= 0,
  };
};
